import HealthData from "@/common/types/healthData";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { HealthList } from "@/components/molecules/HealthList";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { useRecoilValue } from "recoil";
import { GET_HEALTH_INFO } from "@/common/querykeys";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import {
  guardianUserState,
  loginTypeState,
  studentUserState,
} from "@/common/states/user";
import { Loading } from "@/components/atoms/Loading";

export const SettingHealthInfoPage = () => {
  const student = useRecoilValue(studentUserState);
  const navigate = useNavigate();
  const guardian = useRecoilValue(guardianUserState);
  const loginType = useRecoilValue(loginTypeState);

  const {
    data: healthData,
    isPending,
    refetch,
  } = useQuery<HealthData>({
    queryKey: [GET_HEALTH_INFO, student.id],
    queryFn: async () => {
      const studentId =
        loginType === "student" ? student?.id : guardian?.student?.id;

      return await request<HealthData>({
        method: "GET",
        url: `/physical-exam/my-health/${studentId}`,
      });
    },
  });

  const handlePhotoConsent = () => {
    navigate("/spine/photo-agree");
  };

  useEffect(() => {
    refetch();
  }, [student.id, refetch]);

  return (
    <>
      {isPending ? (
        <Loading />
      ) : (
        <>
          <MainTemplate
            nav={false}
            subPage={true}
            menuBtn={false}
            buttonLeft={
              <Buttons
                type="button"
                size="headerTextIcon"
                layout="text"
                color="bright100"
                icon={<IconArrow />}
                label="설정"
                onClick={() => navigate("/setting")}
              />
            }
            buttonRight={
              <Buttons
                type="button"
                size="headerTextIcon"
                layout="text"
                color="bright100"
                label="수정"
                onClick={() => navigate("/setting/health-info/edit")}
              />
            }
            pageTitle="내 건강 정보 관리"
          >
            <div style={{ padding: "16px" }}>
              <HealthList
                data={healthData?.data}
                activeTab="health"
                spineIncluded={false}
                handlePhotoConsent={handlePhotoConsent}
              />
              <HealthList
                data={healthData?.data}
                activeTab="physical"
                handlePhotoConsent={handlePhotoConsent}
              />
            </div>
          </MainTemplate>
        </>
      )}
    </>
  );
};
